import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {AuthenticationService, ValidResourcesResponse} from "../../authentication/authentication.service";
import {EndpointsProvider} from "../endpoints/endpoint-provider.service";

@Injectable()
export class ClientResourcesFetchService {

	constructor(private authService: AuthenticationService, private endpoints: EndpointsProvider) {
	}

	fetch(): Observable<ValidResourcesResponse> {
		const user = this.authService.getUser();
		return user && user.email ? this.endpoints.client.getValidOrders(user.email) : new Observable(subscriber => subscriber.complete());
	}
}
